import { useContext, FC } from 'react'

import { CustomFormAnswer } from 'components/tools/CustomForm/types'
import CustomFormAnswerManagerContext, { CustomFormAnswerManagerType } from './Context'
import { ValidationAnswerRoute } from '../..'

type Props = {
  children: JSX.Element
  answer: CustomFormAnswer
  validationAnswer?: ValidationAnswerRoute
}

const CustomFormAnswerManagerProvider: FC<Props> = ({ children, answer, validationAnswer }) => {
  return (
    <CustomFormAnswerManagerContext.Provider value={{ answer, validationAnswer }}>
      {children}
    </CustomFormAnswerManagerContext.Provider>
  )
}

export default CustomFormAnswerManagerProvider

export const useCustomFormAnswer = () => useContext<CustomFormAnswerManagerType>(CustomFormAnswerManagerContext)
